/**
 * 通过网图url获取file对象
 * @param url 图片地址
 * @param imageName 图片名
 */
function getImageFileFromUrl(url, imageName) {
  // imageName一定要带上后缀
  return new Promise((resolve, reject) => {
    let blob = null;
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${url}?time=${new Date().getTime()}`);
    // xhr.setRequestHeader('Accept', 'image/jpeg');
    xhr.responseType = 'blob';
    xhr.onload = () => {
      if (xhr.status == 200) {
        blob = xhr.response;
        const imgFile = new File([blob], imageName, { type: blob.type });
        resolve(imgFile);
      } else {
        reject();
      }
    };
    xhr.send();
  });
}

const urlToFile = async function (url, imgname) {
  const fileObject = await getImageFileFromUrl(url, imgname);
  return fileObject;
};

export { urlToFile };
